<template>
  <footer>
        <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage1"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            background
            :total="pageTotal">
        </el-pagination>
  </footer>
</template>

<script>
export default {
    props:['pageTotal','pageSize'],
    props:{
        pageTotal:{
            default:1
        },
        pageSize:{
            default:15
        }
    },
    data() {
      return {
        currentPage1: 1,
      };
    },
    methods: {
        handleCurrentChange(val) {
            this.$emit('currentPage',val)
        }
    },
}
</script>

<style lang='scss' scoped>
footer{
    overflow: hidden;
    background: #fff;
    height: 50px;
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
}
</style>